export enum CDocumentKeys {
  Title = "title",
  CaptureDetails = "captureDetails",
  CaptureForm = "captureForm",
  OwnerId = "ownerId",
  MercantileRegistry = "mercantileRegistry",
  PropertyPower = "propertyPower",
  PropertyContract = "propertyContract"
}

export enum CValidationDocumentKeys {
  Trust = "trust",
  NoObjection = "no_objection",
  LegalStatus = "legal_status",
  LandPurchase = "land_purchase",
  Environment = "environment",
  BuildingLicense = "building_license",
  PreviousMitur = "previous_mitur",
  FinalConfotur = "final_confotur",
  Aprocovici = "aprocovici",
  CompanyAssemblyAct = "company_assembly_act",
  EnlargedDueDiligence = "enlarged_due_diligence",
  CreditBureau = "credit_bureau",
  CompanyRnc = "company_rnc",
  MasterPlan = "master_plan",
  CommercialRegister = "commercial_register",
  TrustTransferredTitle = "trust_transferred_title",
  TrustTransferredTitleBuilder = "trust_transferred_title_builder",
  LandTransferTax = "land_transfer_tax",
  DepositAtTownHall = "deposit_at_town_hall",
  LandMovement = "land_movement",
  ConstructionCompanyResume = "construction_company_resume",
  TemporalLegalStatus = "temporal_legal_status",
  Acoprovi = "acoprovi"
}
